
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function FloatingButtons() {
  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleReservation = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector('#contacto');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector('#contacto');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="relative">
          {showWhatsAppTooltip && (
            <div className="absolute bottom-16 right-0 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap">
              ¡Reserva/Pregunta por WhatsApp!
              <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
            </div>
          )}
          <button
            onMouseEnter={() => setShowWhatsAppTooltip(true)}
            onMouseLeave={() => setShowWhatsAppTooltip(false)}
            onClick={() => window.open('https://wa.me/573196152352?text=Hola, me interesa hacer una reserva en Castilletes Parque Tayrona', '_blank')}
            className="w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
          >
            <i className="ri-whatsapp-line text-2xl text-white group-hover:scale-110 transition-transform"></i>
          </button>
        </div>
      </div>

      {/* Fixed Reservation Button - Mobile */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-40 md:hidden">
        <button 
          onClick={handleReservation}
          className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-calendar-check-line mr-2"></i>
          Reservar Ahora
        </button>
      </div>
    </>
  );
}
